import React, { useState, useEffect } from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  NumberInput,
  DateInput,
  useNotify,
  useRedirect,
  useUpdate,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import DynamicZoneInput from '../../../components/admin/DynamicZoneInput/DynamicZoneInput';
import { htmlToBlocks } from '../../../helpers/htmlUtils';

import { uploadImage } from '../../../config/services/strapi/strapi';

function ArticuloEdit(props: any) {
  const [imagesChanged, setImagesChanged] = useState({
    imagen_cubierta: false,
  });

  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();

  const processContent = async(content: any[]) => {
    const token = localStorage.getItem('strapi_jwt');
    if (!token) {
      throw new Error('No se encontró el token de autenticación');
    }
    
    return Promise.all(content.map(async (component: any) => {
      if (component.__component === 'shared.media' && component.imagen.rawFile) {
        const imageResult = await uploadImage(component.imagen.rawFile, token);

        delete imageResult.documentId;

        return {
          __component: 'shared.media',
          imagen: imageResult
        };
      }

      if (component.__component === 'shared.rich-text' && typeof component.contenido === 'string') {
        return { __component: 'shared.rich-text', contenido: htmlToBlocks(component.contenido) };
      }

      delete component.id;

      if (component.__component === 'shared.media') {
        delete component.imagen.documentId;
      }

      return component;
    }));
  }

  const handleSubmit = async(data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      if (!token) {
        notify('No se encontró el token de autenticación', { type: 'error' });
        return;
      }

      const contenido = await processContent(data.contenido);

      const payload = {
        ...data,
        contenido: contenido,
      }

      if (data.imagen_cubierta && data.imagen_cubierta?.rawFile) {
        const imagenCubiertaResult = await uploadImage(data.imagen_cubierta.rawFile, token);
        payload.imagen_cubierta = imagenCubiertaResult;
      }

      delete payload.id;
      delete payload.ref;
      delete payload.createdAt;
      delete payload.publishedAt;
      delete payload.updatedAt;

      if (payload.imagen_cubierta) {
        delete payload.imagen_cubierta.documentId;
      }

      update(
        'articulos',
        { data: payload, id: data.id },
        {
          onSuccess: () => {
            notify('Elemento actualizado');
            redirect('list', 'articulos');
          },
          onError: (error: any) => {
            notify(`Error: ${error.message}`, { type: 'error' });
          },
        }
      );
    }
    catch(error) {
      console.error('Error al actualizar el artículo:', error);
      notify('Error al actualizar el artículo', { type: 'error' });
    }
  };

  useEffect(() => {
    document.title = 'Editar Artículo';
  }, []);

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="titulo" validate={[required()]} />
        <FileInput
          source='imagen_cubierta'
          label='Imagen de Cubierta'
          validate={[required()]}
          onChange={() => setImagesChanged(prev => ({ ...prev, imagen_cubierta: true }))}
        >
          <>
            {imagesChanged.imagen_cubierta && <ImageField source="src" />}
            {!imagesChanged.imagen_cubierta && <ImageField source="url" />}
          </>
        </FileInput>
        <TextInput multiline source="descripcion" validate={[required()]} />
        <NumberInput source="minutos_lectura" validate={[required()]} />
        <DateInput source="fecha" validate={[required()]} />
        <TextInput source="autor" validate={[required()]} />
        <TextInput source="categoria" validate={[required()]} />
        <TextInput source="slug" validate={[required()]} />
        <TextInput source="etiqueta" validate={[required()]} />
        <DynamicZoneInput source="contenido" isEditing />
      </SimpleForm>
    </Edit>
  )
}

export default ArticuloEdit;